<template>
  <v-toolbar flat color="#fb6f3c0d">
    <v-spacer></v-spacer>
    <v-toolbar-title class="font-weight-bold">
      <template v-if="restaurant?.settings.rok_sati">
        <span class="reservation-info-gray">
          {{ $t("ordering_cancelling_shift_change_before") }}
        </span>
        <span class="reservation-info-black">
          {{ switchDay(restaurant.settings.dan).toUpperCase() }} {{ $t("until") }}
          {{ restaurant.settings.broj_sati + ":00" }}
        </span>
      </template>
      <template v-if="restaurant?.settings.rok_dana">
        <template v-if="restaurant.settings.order_before > 0">
          <span class="reservation-info-gray">{{
            $t("order_cancel_change_shift_mandatory")
          }}</span>
          <span class="reservation-info-black">
            {{ restaurant.settings.order_before }}
            {{
              restaurant.settings.order_before == 1
                ? $t("day").toLowerCase()
                : $t("days").toLowerCase()
            }}
            {{ $t("early") }}
            <template v-if="restaurant.settings.order_before_hours > 0">
              , {{ $t("to").toLowerCase() }}
              {{ restaurant.settings.order_before_hours }}
              {{ $t("hours").toLowerCase() }}
            </template>
          </span>
        </template>
        <template v-else>
          {{ $t("order_cancel_change_shift") }}
        </template>
      </template>
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import { mapState } from "vuex";
import { switchDay } from "@/utils/dayShiftUtil";
export default {
  name: "ReservationInfo",
  computed: {
    ...mapState("companyMenu"),
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.$store.state.company.restaurant;
    },
  },
  methods: {
    switchDay,
  },
};
</script>

<style scoped>
.div-okolo {
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 5px;
  border-radius: 12px;
  background: #fb6f3c0d;
}
@media (max-width: 768px) {
  .v-data-table__mobile-row__cell {
    width: 100%;
  }

  .rezervisati {
    font-size: 16px !important;
    text-align: left;
    line-height: 1.4;
  }
}
.reservation-info {
  text-align: center;
  padding: 20px 0;
  font-family: "Poppins", Helvetica, sans-serif !important;
}
.reservation-info-gray {
  color: #606060;
  font-weight: 400;
}
.reservation-info-black {
  color: #000000;
}
</style>
